/*
 * For Production-beta environment
 */
export const BASE_URL = 'https://www.kinomap.com';
export const API_URL = 'https://api.kinomap.com/v3';
export const API_URL_V4 = 'https://api.kinomap.com/v4';

export const OLD_SITE = 'http://dashboard.kinomap.com';
// export const OLD_SITE_VIDEO = 'http://videos.kinomap.com';
export const OLD_SITE_VIDEO = 'http://videos.kinomap.com';
export const OLD_SITE_HOME = 'http://www.kinomap.com';
export const ADMIN_SITE = 'http://admin.kinomap.com/';
export const ADMINV2_SITE = 'https://admin-v2.kinomap.com/';
export const APP_TOKEN =
  '1cey0vihf7f5359ddfaapxxiptpmvqzq9ce12442rzvk1dolflmd7d3bn6egzeofksgh4jwd4wmmmomxcotfqovcc3qkvr342bwk4ga1v5b3ngsshrnfukyj';
export const RECAPTCHA_PK = '6LehTqYZAAAAAOhtzvzAMs5roNWtTrRFyYhiZ6Kj';
export const CREATOR_BASR_URL = 'http://creator.kinomap.com';
export const OAUTH_BASE_URL = 'http://login.kinomap.com';
export const GEOCODE_API_KEY = '65a024d17136e270870926ofv68d9a6';

// Reforestaction Id
// export const REFORESTACTION_EVENT_ID = [57];
export const REFORESTACTION_EVENT_ID = [4, 5, 6];
export const LARGE_SCREEN_BREAKPOINT = 992;

export const environment = {
  websiteBaseUrl: BASE_URL,
  api: {
    auth: API_URL_V4 + '/auth/signIn',
    getOldAccessToken: API_URL_V4 + '/me/getOldAccessToken',
    banner: {
      get: API_URL_V4 + '/admin/banner',
      staticS3: 'https://kinomapstatic.s3.eu-west-1.amazonaws.com/banners_web/',
    },
    coaching: {
      coachingDetails: `${API_URL_V4}/coaching/{coachingId}`,
      coachingIntervals: `${API_URL_V4}/coaching/{coachingId}/interval`,
      coachingUrls: `${API_URL_V4}/coaching/{coachingId}/urls`,
      comments: `${API_URL_V4}/coaching/{coachingId}/comments`,
      deleteComment: `${API_URL_V4}/coaching/{coachingId}/comments/{commentId}`,
      edit: `${API_URL_V4}/coaching/{videoId}/edit`,
      lang: `${API_URL_V4}/coaching/langs?grouped=9999999999999`,
      like: `${API_URL_V4}/coaching/{coachingId}/likes`,
      report: `${API_URL_V4}/coaching/{videoId}/report`,
      setCoachingIntervals: `${API_URL_V4}/coaching/{coachingId}/intervals`,
      updateThumbnail: `${API_URL_V4}/coaching/{hashId}/updateThumbnail`,
      videosByCoach: `${API_URL_V4}/users/{coachId}/videos/coachings`,
    },
    country: API_URL_V4 + '/countries/list',
    dashboard: {
      commentActivity: `${API_URL_V4}/activities/{activity}/sessions/{session}/comments`,
      commentPlaylist: `${API_URL_V4}/playlist/{playlist}/comments`,
      commentVideo: `${API_URL_V4}/scenic/{video}/comments`,
      deleteCommentActivity: `${API_URL_V4}/activities/{activity}/sessions/{session}/comments/{comment}`,
      deleteCommentPlaylist: `${API_URL_V4}/playlists/{playlist}/comments/{comment}`,
      deleteCommentVideo: `${API_URL_V4}/scenic/{video}/comments/{comment}`,
      deleteGpsTrack: `${API_URL_V4}/mapmode/{gpsTrack}`,
      deletePlaylist: `${API_URL_V4}/playlist/{playlist}`,
      deleteVideo: `${API_URL_V4}/scenic/{video-section}`,
      deleteCoaching: `${API_URL_V4}/coaching/{video}`,
      deleteWorkout: `${API_URL_V4}/workout/{workout}`,
      events: `${API_URL_V4}/events`,
      followers: `${API_URL_V4}/me/followers`,
      followings: `${API_URL_V4}/me/followings`,
      followUser: `${API_URL_V4}/users/{user}/followers`,
      lastEvent: `${API_URL_V4}/admin/last-event`,
      likeActivity: `${API_URL_V4}/activities/{activity}/sessions/{session}/likes`,
      likePlaylist: `${API_URL_V4}/playlists/{playlist}/likes`,
      likeVideo: `${API_URL_V4}/scenic/{video}/likes`,
      myActivitiesSessions: `${API_URL_V4}/me/activities/sessions`,
      myAudience: `${API_URL_V4}/me/myAudience`,
      myCoachingVideos: `${API_URL_V4}/me/coachings`,
      myContributionSummary: `${API_URL_V4}/me/contribution/summary`,
      myEquipments: `${API_URL_V4}/me/equipments`,
      myFavorites: `${API_URL_V4}/me/favorites/scenics`,
      myFavoritesAddPlaylist: `${API_URL_V4}/me/favorites/playlists/{playlist}`,
      myGpsOnly: `${API_URL_V4}/me/mapmodes`,
      myPlaylists: `${API_URL_V4}/me/playlists`,
      myRecentlyUploadedVideos: `${API_URL_V4}/me/videosUploaded`,
      mySettings: `${API_URL_V4}/me/settings`,
      mySubscription: `${API_URL_V4}/me/subscription`,
      myTrainingLog: `${API_URL_V4}/me/training/log`,
      myVideos: `${API_URL_V4}/me/scenics`,
      myWorkouts: `${API_URL_V4}/me/workouts`,
      plans: `${API_URL_V4}/subscription/stripe/plans`,
      recommendedFollows: `${API_URL_V4}/me/recommended/follows`,
      stripe: `${API_URL_V4}/me/subscription/stripe`,
      subComments: `${API_URL}/comments/{commentId}`,
      timelineSubscriptions: `${API_URL_V4}/me/subscription/getV2`,
      trainingLog: `${API_URL}/users/training/log`,
      userBadges: `${API_URL_V4}/badges`,
      videoInformations: `${API_URL_V4}/scenic/{videoId}`,
      videosPolylines: `${API_URL}/users/{user}/videos/polylines`,
      workout: {
        favorite: `${API_URL_V4}/me/favorites/workouts`,
      },
      giftCards: `${API_URL_V4}/subscription/stripe/giftCards`,
    },
    equipments: {
      list: API_URL_V4 + '/equipments',
    },
    event: {
      get: API_URL_V4 + '/events/',
    },
    externalUser: {
      activitiesSessions: API_URL_V4 + '/users/{userId}/activities/sessions',
      badges: API_URL_V4 + '/users/{userId}/badges',
      coachingVideos: API_URL_V4 + '/users/{userId}/videos/coachings',
      contributionSummary: `${API_URL_V4}/users/{userId}/contribution/summary`,
      followers: API_URL_V4 + '/users/{userId}/followers',
      followings: API_URL_V4 + '/users/{userId}/followings',
      information: API_URL_V4 + '/users/{userId}',
      playlists: API_URL_V4 + '/users/{userId}/playlists',
      videos: API_URL_V4 + '/users/{userId}/videos/scenics',
      workouts: API_URL_V4 + '/users/{userId}/videos/workouts',
    },
    me: API_URL_V4 + '/me',
    myAccount: API_URL_V4 + '/me/parameters/general',
    myTrainingStats: {
      getPPR: API_URL_V4 + '/me/ppr',
    },
    playlists: {
      getPlaylist: API_URL_V4 + '/playlist/{playlistId}',
    },
    register: API_URL_V4 + '/auth/signUp',
    setting: {
      confidentiality: API_URL_V4 + '/me/account/confidentiality',
      deleteAccount: API_URL_V4 + '/me/deleteAccount',
      display: API_URL_V4 + '/me/account/display',
      heartRate: API_URL_V4 + '/me/account/performances/heartrate',
      notification: API_URL_V4 + '/me/account/notifications',
      personalAccount: API_URL_V4 + '/me/parameters/personal',
      security: API_URL_V4 + '/me/parameters/security',
      shared: {
        callback: 'https://dashboard.kinomap.com/en/oauth/callback/',
        adidas: {
          clientId: 'papi_kinomap',
          clientSecret:
            'oBkDDolfFe1Dbj1LQAO26SqrN97qp4cqCDCCjMhVGlTWaqRYI8zJxcJpgeJhgIWm6AdjaOaqsuMm4DG3NoP52uyr9hiMfUvaMj7EQuw2leWs2MRDU75kg6rpbq0xVRMVPA1GcIONk54z533EJwPDclWFELwrRQ7TfBLYqBNaEPDbYZX1xvLLFsJWFukIa5lN2Kt72ZAtImFet599Mg2BY0LcnBF7Cgouotg38ARAR0d2VNQ2bqlT8vjFoMGJMzKNz7yOB8lnsoMbRCqRwBMlw90CncrgmuIWNKFbZvV2PY0RJ9T1PL2E4vNgkuqQJVJWmP1tSajdycrQmAqvQoqNQ65F',
          endpoint:
            'https://accounts.runtastic.com/v1/as/authorization.oauth2?',
        },
        decathlon: {
          appId: '0cd4eea3-363d-4606-9faa-a93fcac6d946',
          appSecret:
            '5Bo6Rv32x6LO4U0jtXj02YsnC3aQeGcAbaoskldgYfXYlB3tEUpFL1xkNvNJ5BAHrpGJja0FJPe7DfluzY96cTjD0pjXF03i0cqOlBNYKXaVgN9dsgGtQcHwAEk93s0s',
          decathlonDomain: 'https://api.decathlon.net/connect/oauth/authorize',
          ldidDomain:
            'https://api.preprod.decathlon.net/sportstrackingdata/v2/me',
          profileDomain:
            'https://api.preprod.decathlon.net/identity/v1/members/profile/me',
          redirectUri:
            'https://www.kinomap.com/dashboard/setting/share/callback/decathlon',
          xApiKeyProfile: '161f829a-07bd-4b79-9e2e-f701937179c2',
          xApiKeySportTracking: 'b319bf83-e31a-49a2-80a3-d3236297e3d6',
        },
        LogBook: {
          clientId: 'h7t4djGhVopm428nae92RGG3mX7apqu0dAidDgxn',
          clientSecret: 'qTCsGOTodWdVLeJOEciJD8oQLA0qRm6reO0NbITi',
          endpoint: 'https://log.concept2.com/oauth/authorize?',
        },
        nolio: {
          clientId: 'sCZ6TLQg0ZWnOTBq0mBISNkYmNsMWryLVcSFkSdt',
          clientSecret:
            'rASQuKFSA9lAEr3DkPLlErEY89fHI7NXascE0H19awv1srEEV3yelLifgllxaOMhc0EAYFJHAmKlSKZ8nRm6OtLdI7xT3yazVA7xAzJkszuiBdahgzcdBr9IB1KWB4ve',
          endpoint: 'https://www.nolio.io/api/authorize?',
        },
        runKeeper: {
          clientId: 'bd209d991728451497326d0573b57f93',
          url: 'https://runkeeper.com/apps/authorize?',
        },
        strava: {
          clientId: 22520,
          strava_url: 'https://www.strava.com/oauth/authorize',
          redirect_uri:
            'https://dashboard.kinomap.com/en/oauth/callback/strava',
        },
        trainingPeaks: {
          training_peaks_key: 'kinomap',
          training_peaks_request_url:
            'https://oauth.trainingpeaks.com/oauth/authorize',
          training_peaks_secret: 'Etwmt75d9GgJiwtMFp3A1xLhHKRZ4JnhNQRPh8Iwr8',
        },
      },
      sharing: API_URL_V4 + '/me/account/sharing',
      sharingParameters: API_URL_V4 + '/me/parameters/sharing',
      updateInfos: API_URL_V4 + '/me/parameters/general',
    },
    stripe: {
      confirmSubscription: API_URL_V4 + '/stripe/confirmSubscription',
      createOrder: API_URL_V4 + '/stripe/createOrder',
      createSubscription: API_URL_V4 + '/stripe/createSubscription',
      getAllPlans: API_URL_V4 + '/stripe/getAllPlans',
    },
    swarm: {
      apple: API_URL_V4 + '/auth/loginApple',
      decathlon: API_URL_V4 + '/auth/loginDecathlon',
      google: API_URL_V4 + '/auth/loginGoogle',
      strava: API_URL_V4 + '/auth/loginStrava',
    },
    timeline: {
      global: `${API_URL_V4}/me/feed`,
      personal: `${API_URL_V4}/me/timeline/personal`,
    },
    trainingLog: {
      activityDetails: `${API_URL_V4}/activities/{activityId}/details`,
      activityInformations: `${API_URL_V4}/activities/{activityId}`,
      activitySessionLikes: `${API_URL_V4}/activities/{activityId}/sessions/{sessionId}/likes`,
      getSharablePlatforms: `${API_URL_V4}/me/sharable`,
      getWorkout: `${API_URL_V4}/workout/{workoutId}`,
      shareActivity: `${API_URL_V4}/activities/{activityId}/sessions/{sessionId}/share`,
      updateActivity: `${API_URL_V4}/activities/{activityId}/status`,
    },
    user: {
      deleteAvatar: API_URL_V4 + '/me/deleteAvatar',
      getUiAvatar: API_URL_V4 + '/users/getUiAvatar',
      recoverPassword: API_URL_V4 + '/users/recover',
      updateAvatar: API_URL_V4 + '/me/updateAvatar',
      updateInfos: API_URL_V4 + '/users/updateInfos',
      validateCaptcha: API_URL_V4 + '/users/validateCaptcha',
    },
    watch: {
      addVideoToPlaylist: `${API_URL_V4}/playlist/{playlist}/add`,
      createNewPlaylist: `${API_URL_V4}/playlist`,
      edit: `${API_URL_V4}/scenic/{videoId}/edit`,
      equipments: `${API_URL_V4}/equipments`,
      getStravaSection: `${API_URL_V4}/scenic/{videoId}/stravaSegments`,
      getVideoFromPlaylist: `${API_URL_V4}/playlist/{playlist}/videos`,
      getVideoGPX: `${API_URL_V4}/scenic/{videoId}/gpxFile`,
      mapModeTop3: `${API_URL_V4}/mapmode/{videoId}/activities/top3`,
      myPlaylists: `${API_URL_V4}/me/playlists/all`,
      ranking: `${API_URL_V4}/scenic/{videoId}/activities/ranking`,
      reportComment: `${API_URL_V4}/comments/{commentId}/report`,
      reportVideo: `${API_URL_V4}/scenic/{videoId}/report`,
      top3: `${API_URL_V4}/scenic/{videoId}/activities/top3`,
      updateThumbnail: `${API_URL_V4}/scenic/{hashId}/updateThumbnail`,
    },
    gpsOnly: {
      informations: `${API_URL_V4}/mapmode/{gpsOnlyId}`,
      comments: `${API_URL_V4}/mapmode/{gpsOnlyId}/comments`,
      likes: `${API_URL_V4}/mapmode/{gpsOnlyId}/likes`,
      ranking: `${API_URL_V4}/mapmode/{gpsOnlyId}/activities/ranking`,
      weekly: `${API_URL_V4}/mapmode/weekly`,
      recommended: `${API_URL_V4}/gpsOnly/recommended`,
      coordinates: `${API_URL_V4}/mapmode/{gpsOnlyId}/coordinates`,
      trainingSections: `${API_URL_V4}/mapmode/{gpsOnlyId}/training-sections`,
    },
    workout: {
      comments: `${API_URL_V4}/workout/{workoutId}/comments`,
      recommended: `${API_URL_V4}/workout/recommended`,
      byUser: `${API_URL_V4}/users/{userId}/videos/workouts`,
      likes: `${API_URL_V4}/workout/{workoutId}/likes`,
      report: `${API_URL_V4}/users/reportIssue`,
    },
    recommended: `${API_URL_V4}/{type}/recommended`,
  },

  oauth: {
    url: OAUTH_BASE_URL,
  },
  apple: {
    redirect_url: 'https://www.kinomap.com/v2/login/apple',
  },
  baseUrl: OLD_SITE,
  creator: {
    workoutEdition: `${CREATOR_BASR_URL}/workout/create/{workoutId}`,
  },
  creatorUrl: CREATOR_BASR_URL,
  decathlon: {
    config: {
      client_id: '0cd4eea3-363d-4606-9faa-a93fcac6d946',
      client_secret:
        '0cTZNom4AZ1dHaIFHA3gksJsIvkegI8vQ4wNEtKHY0MqgLtEzanNCTy42Im1HcGJfvgIMNZ8BCFTUTxtyC0R7pcfv1Upw6yAUpLQs05uHRAMnrBHqRZtogncdlrhedQC',
    },
    dataUrl: 'https://api-global.decathlon.net/connect/oauth/token',
    loginUrl: 'https://api-global.decathlon.net/connect/oauth/authorize',
    redirectUrl: 'http://www.kinomap.watch/v2/login/decathlon',
  },
  google: {
    client_id:
      '466170937286-7ko89334cm4cvrt4pa1728cdmp5he3qi.apps.googleusercontent.com',
    googlePlacesApiKey: 'AIzaSyCBBJm6GXBCMDi0smKyDo1L5EJQDbiLV04',
  },
  oldWebsite: {
    url: {
      editCoaching: `${OLD_SITE_VIDEO}/en/videos_coaching/edit/{videoHashId}`,
      editGpsTrack: `${OLD_SITE}/en/gpsTrack/edit/{gpsTrackId}`,
      editPlaylist: `${OLD_SITE_VIDEO}/{lang}/playlists/edit/{playlistId}`,
      editVideo: `${OLD_SITE_VIDEO}/en/videos/edit/{videoHashId}`,
      subscriptions: `${OLD_SITE}/en/subscriptions`,
      upload: `https://uploader-v2.kinomap.com?userAccessToken={userAppToken}&lang={lang}`,
      viewActivity: `${OLD_SITE}/en/activities/{activityId}`,
      viewPlaylist: `${OLD_SITE_VIDEO}/{lang}/playlists/{playlistId}`,
      viewVideo: `${OLD_SITE_VIDEO}/en/watch/{videoHashId}`,
    },
  },
  production: true,
  redirection: {
    oldAccountEdition: `${OLD_SITE}/en/account`,
  },
  strava: {
    client_id: 22520,
    client_secret: '97c8b931e57a177f1d8072c719545d82fa6050d8',
    loginUrl: 'https://www.strava.com/oauth/authorize',
    redirectUrl: 'http://localhost:4200/login/strava',
    tokenUrl: 'https://www.strava.com/oauth/token',
  },
  stripe: {
    public: 'pk_live_LVUkkQK9ZGYlF1zJjOjNFJhS',
  },
};
